import algoliasearch from 'algoliasearch'

// get Algolia COLLECTION index raw search results / hits
// NOTE: SORTING - we cannot sort by just any field / direction, we have to create a virtual algolia index with the correct sorting and then use the replica name as the sortingReplica param
export const getAlgoliaCollections = async ({ page = 0, perPage = 25, term = false, category = false, sortingReplica = false, whereArray = false, visibleOnly = false }) => {
    // get / create the correct index (may need a different replica for different sorting)
    const indexName = sortingReplica ? `${process.env.GATSBY_ALGOLIA_INDICE}-${sortingReplica}`: process.env.GATSBY_ALGOLIA_INDICE

    // setup Algolia
    const algolia = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY)
    const index = algolia.initIndex(indexName)

    // either use provided term, or empty string
    term = term || ''

    // create base filters
    const facetFilters = ['active:true']
    let numericFilters = ''

    // add visiblity filters
    if (visibleOnly) facetFilters.push('visibility:public')

    // add category filters (if given) - kept in nested array as we want to OR them internally
    if (category && Array.isArray(category) && category.length) {
        const categoryFilters = category.map((cat) => `categories:${cat}`)
        facetFilters.push(categoryFilters)
    }

    // sorting - handled by index / replica used (at the start of this function)

    // Year Filters
    if (whereArray.length) {
        const yearFilters = []
        Object.entries(whereArray).map(([key, where]) => {
            yearFilters.push(where.item + where.operator + where.value)
        })
        numericFilters =(yearFilters.join(','))
    }

    // run query with all params (inc. pagination)
    const params = { page, hitsPerPage: perPage, facetFilters, numericFilters, typoTolerance: 'min' }
    const algoliaResponse = await index.search(term, params)

    // return all results + extra search info
    return { hits: algoliaResponse.hits, page: algoliaResponse.page, nbPages: algoliaResponse.nbPages }
}

export const getAlgoliaPosts = async ({ term = '', page = 0, perPage = 25 }) => {
    const algolia = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY)
    const index = algolia.initIndex(process.env.GATSBY_ALGOLIA_POST_INDICE)
    const filter = { page, hitsPerPage: perPage, typoTolerance: 'min' }

    filter.facetFilters = []
    filter.facetFilters.push('visibility:public')

    let hits = []
    if (term !== '') {
        hits = await index.search(term, filter)
    }

    return hits
}
